<app-single-select-dropdown
	[label]="label()"
	[opties]="allOptions"
	[selectedOptie]="findOption()"
	(onOptieClicked)="select($event)"
	placeholder="(kies...)"
>
</app-single-select-dropdown>
